import React from 'react';
import _ from 'lodash';
import ProjectScopeCard from "./ProjectScopeCard";
import ProjectScopeCardNew from "./ProjectScopeCardNew";
import {SortableContainer, SortableElement} from 'react-sortable-hoc'; // https://github.com/clauderic/react-sortable-hoc
import NewFeatureGroup from "./NewFeatureGroup";
import {SortByMode} from './SortByMode';
import ProjectScopeContentHeader from "./ProjectScopeContentHeader";

const SortableItem = SortableElement(({value}) => <li>{value}</li>);

const getDummyContainers = () => {
  let dummyItems = [];
  for (let i = 0; i <= 4; i++) {
    dummyItems.push(<li key={"dummy" + i} className="pj-scope-lir pj-scope-lir-flex-dummy"/>)
  }
  return dummyItems
};

const SortableList = SortableContainer(({items, activeQtCategoryIndex, showMode = false, setMode, mode}) => {
  return (
    <div className="pj-scope-content">
      <ProjectScopeContentHeader/>
      <ul className={"pj-scope-flex-container"}>
        {!activeQtCategoryIndex ? <NewFeatureGroup newScope={true}/> : null}
        {items.map((value, index) => (
          <SortableItem key={`item-${index}`} index={index} value={value}/>
        ))}
        {getDummyContainers()}
      </ul>
    </div>
  );
});

const ProjectScopeCardCreator = (isNew, props) => {
  return isNew ? <ProjectScopeCardNew {...props} /> : <ProjectScopeCard {...props}/>;
};

/**
 *
 * @param activeQtCategoryIndex {number}
 * @param removeFeatureGroupFromCategory {function}
 * @param isNew {boolean}
 * @returns {*}
 * @constructor
 */
export default function ProjectScopeSortableItems(activeQtCategoryIndex, removeFeatureGroupFromCategory, isNew = false) {

  const items = this.state.reorderedFeatureGroups.map((featureGroup,) => {
    let _featureGroup = featureGroup;
    let _pIdx = _.findIndex(this.props.pendingChanges, pc => pc.groupName == featureGroup.groupName);
    if(_pIdx >= 0) {
      _featureGroup = {...this.props.pendingChanges[_pIdx]};
    }

    return ProjectScopeCardCreator(isNew, {
      featureGroup: _featureGroup,
      activeQtCategoryIndex: activeQtCategoryIndex,
      removeFeatureGroupFromCategory: removeFeatureGroupFromCategory,
      getFeatureCreatorLink: this.getFeatureCreatorLink,
      isUnsaved: featureGroup.unsaved,
      newScope: true
    })
  });

  return (
    <SortableList items={items}
                  activeQtCategoryIndex={activeQtCategoryIndex}
                  helperClass='sortableHelper'
                  onSortEnd={this.onSortEnd}
                  onSortStart={this.onSortStart}
                  shouldCancelStart={this.shouldCancelStart}
                  axis={"xy"}
                  setMode={this.props.setMode}
                  mode={this.props.mode}
    />
  )
}
